import GroupPill from './GroupPill.component';

export default GroupPill;
